/**
 * @generated SignedSource<<ecf0010a1c6370c50f91b6e67a899e45>>
 * @relayHash e26f23ae6c1cefd68296b4e808e4a7b9
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e26f23ae6c1cefd68296b4e808e4a7b9

import { ConcreteRequest } from 'relay-runtime';
export type CareProviderGroupType = "CHIROPRACTOR" | "DENTIST" | "DOCTOR" | "HOSPITAL" | "NONE" | "NUTRITIONIST" | "PHARMACY" | "PHYSIOTHERAPIST" | "PSYCHOTHERAPIST";
export type CareProviderSearchType = "ADVANCED_SEARCH" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE_WITHOUT_SPECIALTY" | "HOSPITAL_ELECTIVE_WITH_SPECIALTY" | "HOSPITAL_EMERGENCY_ROOM" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "NONE" | "PRESCRIPTION_DOCUMENT" | "SPECIALIST_WITHOUT_SPECIALTY" | "SPECIALIST_WITH_SPECIALTY" | "THERAPY_PRESCRIPTION_NEUROPSYCHOLOGIC_DIAGNOSTIC_DOCUMENT" | "THERAPY_PRESCRIPTION_NUTRITIONAL_COUNSELLING_DOCUMENT" | "THERAPY_PRESCRIPTION_PHYSIOTHERAPY_DOCUMENT" | "THERAPY_PRESCRIPTION_PSYCHOLOGICAL_PSYCHOTHERAPY_DOCUMENT" | "TIME_WINDOW_WITH_REFERRAL_TO" | "TIME_WINDOW_WITH_REFERRED_BY";
export type DayOfWeek = "FRIDAY" | "MONDAY" | "SATURDAY" | "SUNDAY" | "THURSDAY" | "TUESDAY" | "WEDNESDAY";
export type WorkingType = "CLOSED" | "HOURLY" | "OPEN24_HOURS";
export type CareProviderAdvancedSearchInput = {
  canton?: string | null;
  careProviderGroupId?: string | null;
  certificateIds: ReadonlyArray<string>;
  currentAddress?: GeoStructuredAddressInput | null;
  diagnosticFacilitiesIds: ReadonlyArray<string>;
  flagFilters?: CareProviderFlagFilterInput | null;
  focusId?: string | null;
  insuranceCareProviderListIds?: ReadonlyArray<string> | null;
  officialLanguageIds: ReadonlyArray<string>;
  searchText: string;
  searchType: CareProviderSearchType;
  serviceId?: string | null;
  specializationId?: string | null;
  specialtyId?: string | null;
  subjectAreaId?: string | null;
  top?: number;
};
export type GeoStructuredAddressInput = {
  countryCode: string;
  municipality: string;
  postalCode: string;
  streetName: string;
};
export type CareProviderFlagFilterInput = {
  isHandleAdultEmergency: boolean;
  isHandleChildEmergency: boolean;
  isHomeTreatment: boolean;
  isMedgatePartnerNetworkMember: boolean;
  isPartnerPortalMember: boolean;
  isRecommendedForReferral: boolean;
  isTakesNewPatients: boolean;
  isTelemedicine: boolean;
  isWalkIn: boolean;
  isWheelchairAccessible: boolean;
};
export type useAdvancedCareProviderSearchQuery$variables = {
  input: CareProviderAdvancedSearchInput;
  language: string;
};
export type useAdvancedCareProviderSearchQuery$data = {
  readonly ch_careProviderAdvancedSearch: {
    readonly results: ReadonlyArray<{
      readonly additionalAddress: string | null;
      readonly businessName: string | null;
      readonly careProviderGroupQuickList: {
        readonly groupType: CareProviderGroupType;
      };
      readonly careProviderSpecialtyTranslations: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
      readonly city: string | null;
      readonly country: {
        readonly countryName: string | null;
      } | null;
      readonly countryCode: string | null;
      readonly creditorCodeRegister: string | null;
      readonly detailedSchedule: ReadonlyArray<{
        readonly day: DayOfWeek;
        readonly periods: ReadonlyArray<{
          readonly end: string;
          readonly start: string;
        }> | null;
        readonly workingType: WorkingType;
      }> | null;
      readonly distance: number | null;
      readonly email: string | null;
      readonly firstName: string | null;
      readonly globalLocationNumber: number | null;
      readonly groupName: string | null;
      readonly highlights: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }> | null;
      readonly id: string;
      readonly insuranceCareProviderListIds: ReadonlyArray<string> | null;
      readonly isMedgatePartnerNetworkMember: boolean | null;
      readonly isTakesNewPatients: boolean | null;
      readonly lastName: string | null;
      readonly network: {
        readonly name: string;
      } | null;
      readonly officialLanguageIds: ReadonlyArray<number> | null;
      readonly phoneNumber: string | null;
      readonly postalCode: string | null;
      readonly relationBusinessName: string | null;
      readonly relationFirstName: string | null;
      readonly relationLastName: string | null;
      readonly relationTitle: string | null;
      readonly relationType: string | null;
      readonly streetAddress: string | null;
      readonly title: string | null;
      readonly website: string | null;
    }>;
  };
};
export type useAdvancedCareProviderSearchQuery = {
  response: useAdvancedCareProviderSearchQuery$data;
  variables: useAdvancedCareProviderSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "language"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetAddress",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "website",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalAddress",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialLanguageIds",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creditorCodeRegister",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "distance",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "globalLocationNumber",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "KeyValuePairOfStringAndString",
  "kind": "LinkedField",
  "name": "highlights",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "value",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationBusinessName",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationFirstName",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationLastName",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationTitle",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationType",
  "storageKey": null
},
v25 = [
  {
    "kind": "Variable",
    "name": "language",
    "variableName": "language"
  }
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": (v25/*:: as any*/),
  "concreteType": "SpecialtyTranslation",
  "kind": "LinkedField",
  "name": "careProviderSpecialtyTranslations",
  "plural": true,
  "selections": [
    (v2/*:: as any*/),
    (v26/*:: as any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupType",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": (v25/*:: as any*/),
  "kind": "ScalarField",
  "name": "countryName",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": (v25/*:: as any*/),
  "kind": "ScalarField",
  "name": "groupName",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMedgatePartnerNetworkMember",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "insuranceCareProviderListIds",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTakesNewPatients",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "DaySchedule",
  "kind": "LinkedField",
  "name": "detailedSchedule",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "day",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "workingType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TimePeriod",
      "kind": "LinkedField",
      "name": "periods",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdvancedCareProviderSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SearchTextResultOfCareProviderSearchResult",
        "kind": "LinkedField",
        "name": "ch_careProviderAdvancedSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CareProviderSearchResult",
            "kind": "LinkedField",
            "name": "results",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v27/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProviderGroup",
                "kind": "LinkedField",
                "name": "careProviderGroupQuickList",
                "plural": false,
                "selections": [
                  (v28/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryLookup",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v29/*:: as any*/)
                ],
                "storageKey": null
              },
              (v30/*:: as any*/),
              (v31/*:: as any*/),
              (v32/*:: as any*/),
              (v33/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Network",
                "kind": "LinkedField",
                "name": "network",
                "plural": false,
                "selections": [
                  (v26/*:: as any*/)
                ],
                "storageKey": null
              },
              (v34/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useAdvancedCareProviderSearchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SearchTextResultOfCareProviderSearchResult",
        "kind": "LinkedField",
        "name": "ch_careProviderAdvancedSearch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CareProviderSearchResult",
            "kind": "LinkedField",
            "name": "results",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/),
              (v15/*:: as any*/),
              (v16/*:: as any*/),
              (v17/*:: as any*/),
              (v18/*:: as any*/),
              (v19/*:: as any*/),
              (v20/*:: as any*/),
              (v21/*:: as any*/),
              (v22/*:: as any*/),
              (v23/*:: as any*/),
              (v24/*:: as any*/),
              (v27/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CareProviderGroup",
                "kind": "LinkedField",
                "name": "careProviderGroupQuickList",
                "plural": false,
                "selections": [
                  (v28/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryLookup",
                "kind": "LinkedField",
                "name": "country",
                "plural": false,
                "selections": [
                  (v29/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v30/*:: as any*/),
              (v31/*:: as any*/),
              (v32/*:: as any*/),
              (v33/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_Network",
                "kind": "LinkedField",
                "name": "network",
                "plural": false,
                "selections": [
                  (v26/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v34/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "e26f23ae6c1cefd68296b4e808e4a7b9",
    "metadata": {},
    "name": "useAdvancedCareProviderSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "60015fbe1506ac6129a0af4e7b843145";

export default node;
